import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from '../../../components/PrivateRoute';
import { Container } from './styles';

import Administrators from '../../pages/Administrators';
import AddAdministrator from '../../pages/AddAdministrator';
import Events from '../../pages/Events';
import EventDetail from '../../pages/EventDetail';
import EventReport from '../../pages/EventReport';
import NotFound from '../../pages/NotFound';
import PendingEvents from '../../pages/PendingEvents';
import PendingPromoters from '../../pages/PendingPromoters';
import Producers from '../../pages/Producers';
import Promoters from '../../pages/Promoters';
import Sidebar from '../Sidebar';
import TopHeader from '../../../components/TopHeader';
import UpdateFollowers from '../../pages/UpdateFollowers';

const Base = () => (
  <Container className="admin-panel">
    <TopHeader />
    <Sidebar />
    <div className="dashboard">
      <main>
        <Switch>
          <PrivateRoute exact path="/admin/dashboard/" component={PendingPromoters} />
          <PrivateRoute exact path="/admin/dashboard/administrators" component={Administrators} />
          <PrivateRoute
            exact
            path="/admin/dashboard/administrators/create"
            component={AddAdministrator}
          />
          <PrivateRoute exact path="/admin/dashboard/events" component={Events} />
          <PrivateRoute exact path="/admin/dashboard/events/:id" component={EventDetail} />
          <PrivateRoute exact path="/admin/dashboard/events/:id/report" component={EventReport} />
          <PrivateRoute exact path="/admin/dashboard/promoters" component={Promoters} />
          <PrivateRoute exact path="/admin/dashboard/producers" component={Producers} />
          <PrivateRoute
            exact
            path="/admin/dashboard/update-followers"
            component={UpdateFollowers}
          />
          <PrivateRoute exact path="/admin/dashboard/pending-events" component={PendingEvents} />
          <PrivateRoute
            exact
            path="/admin/dashboard/pending-promoters"
            component={PendingPromoters}
          />
          <Route component={NotFound} />
        </Switch>
      </main>
    </div>
  </Container>
);

export default Base;



// WEBPACK FOOTER //
// ./src/admin/components/Base/index.js